import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/Login";
import Login2 from "@/components/Login2";
import Perguntas from "@/components/Perguntas";
import Videos from "@/components/Videos";
import RadiosButton from "@/components/RadiosButton";
import Dashboard from "@/components/Dashboard";
import Clientes from "@/components/Clientes";
import Usuarios from "@/components/Usuarios";
import Settings from "@/components/Settings";
import Acessos from "@/components/Acessos";
import Voucher from "@/components/Voucher";
import Radios from "@/components/Radios";
import OverView from "@/components/OverView";
import Testes from "@/components/Teste";
import Maps from "@/components/Maps";
import Mapsteste from "@/components/Mapsteste";
import Notifications from "@/components/Notifications";
import store from "@/store.js";
import Email from "@/components/Email";
import emailNv from "@/components/emailNv";
import Birthday from "@/components/Birthday";
import Sms from "@/components/Sms";
import smsNv from "@/components/smsNv";
import Recurrence from "@/components/Recurrence";
import Relatorios from "@/components/Relatorios";

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/dashboard"
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        access: "ALLOW",
        targets: ["all"]
      }
    },
    {
      path: "/login2",
      name: "Login2",
      component: Login2,
      meta: {
        access: "ALLOW",
        targets: ["all"]
      }
    },
    {
      path: "/direct_auth/:token",
      name: "DirectAuth",
      component: Login,
      props: true,
      meta: {
        access: "ALLOW",
        targets: ["all"]
      }
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },
    {
      path: "/videos",
      name: "Vídeos",
      component: Videos,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },

    {
      path: "/radios-button",
      name: "Vídeos",
      component: RadiosButton,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },
    {
      path: "/perguntas",
      name: "Perguntas",
      component: Perguntas,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },
    {
      path: "/acessos",
      name: "Acessos",
      component: Acessos,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },
    {
      path: "/clientes",
      name: "Clientes",
      component: Clientes,
      meta: {
        access: "ALLOW",
        targets: ["root"]
      }
    },

    {
      path: "/usuarios",
      name: "Usuários",
      component: Usuarios,
      meta: {
        access: "ALLOW",
        targets: ["admin", "root"]
      }
    },
    {
      path: "/notifications",
      name: "Notificações",
      component: Notifications,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },
    {
      path: "/settings",
      name: "Configurações",
      component: Settings,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },
    {
      path: "/testes",
      name: "Testes",
      component: Testes,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },
    //alterado aqui
    {
      path: "/voucher",
      name: "Voucher",
      component: Voucher,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },
    {
      path: "/radios",
      name: "Radios",
      component: Radios,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },

    {
      path: "/overView",
      name: "OverView",
      component: OverView,
      meta: {
        access: "ALLOW",
        targets: ["admin", "root"]
      }
    },
    {
      path: "/maps",
      name: "Mapas",
      component: Maps,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },
    {
      path: "/relatorios",
      name: "Relatórios",
      component: Relatorios,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },
    /*
     */
    {
      path: "/mapsteste",
      name: "MapasTeste",
      component: Mapsteste,
      meta: {
        access: "ALLOW",
        targets: ["admin", "root"]
      }
    },
    {
      path: "/emails",
      name: "Email",
      component: emailNv,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },
    {
      path: "/birthday",
      name: "Aniversario",
      component: Birthday,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },
    {
      path: "/sms",
      name: "Sms",
      component: smsNv,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },
    {
      path: "/recurrence",
      name: "Recurrence",
      component: Recurrence,
      meta: {
        access: "ALLOW",
        targets: ["auth", "admin", "root"]
      }
    },
    {
      path: "*",
      redirect: "/dashboard"
    }
  ]
});

router.beforeEach((to, from, next) => {
  var role = store.getters.isROOT
    ? "root"
    : store.getters.isADM
    ? "admin"
    : store.getters.isLoggedIn
    ? "auth"
    : "all";

  if (to.matched.some(rec => rec.meta.access == "ALLOW")) {
    if (to.matched.some(rec => rec.meta.targets.includes(role))) {
      next();
    } else next("/login");
  } else if (to.matched.some(rec => rec.meta.access == "DENY")) {
    if (to.matched.some(rec => !rec.meta.targets.includes(role))) {
      next();
    } else next("/login");
  } else {
    next("/login");
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js